<template>
  <div id="introduction">
    <div class="card bg-gradient-default shadow">
      <div class="card-body">
        <FinancialsPie />
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-6">
        <div class="card bg-gradient-default shadow">
          <div class="card-body">
            <img class="img-fluid" src="https://firebasestorage.googleapis.com/v0/b/cclbc-annual-report-2018.appspot.com/o/images%2Ffinance1.jpg?alt=media&token=0a398b12-2522-46b9-b3ea-dbd259bd04b7">
          </div>
        </div>
      </div><!-- /.col-md-6 -->
      <div class="col-md-6">
        <div class="card bg-gradient-default shadow">
          <div class="card-body">
            <img class="img-fluid" src="https://firebasestorage.googleapis.com/v0/b/cclbc-annual-report-2018.appspot.com/o/images%2Ffinance2.jpg?alt=media&token=6a7fdee2-2fa0-4c5a-b92e-3054356ede43">
          </div>
        </div>
      </div><!-- col-md-6 -->
    </div><!-- /.row -->

  </div>
</template>

<script>
import FinancialsPie from './FinancialsPie'

export default {
  components: {
    FinancialsPie
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Outcomes.vue